import { Grid, Tooltip, Typography } from '@material-ui/core';
import { equals } from 'ramda';
import { useSelector } from 'react-redux';

import { Clipboard } from '~components/Clipboard/Clipboard';
import { AppInfo } from '~models/app';

import { selectors } from '~store';

type AllVersionsInfoProps = {
  info: AppInfo;
};

export const AllVersionsInfo = ({ info: { version, beVersion, feVersion, jenkinsVersion } }: AllVersionsInfoProps) => {
  const isAdminUser = useSelector(selectors.auth.isAdminUser, equals);
  const clipbardText = `Version: ${version}\nBack End Version: ${beVersion}\nFront End Version: ${feVersion}\nJenkins Version: ${jenkinsVersion}`;

  if (!isAdminUser) {
    return <Grid>{version}</Grid>;
  }

  return (
    <Tooltip
      interactive
      title={
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Clipboard
              text={clipbardText}
              tipText="Copy All Versions info"
              placement="right"
              isIconButton
            />
          </Grid>
          <Grid item xs={6}><Typography variant="h4" color="primary">Back End Version:</Typography></Grid>
          <Grid item xs={6}>{beVersion}</Grid>
          <Grid item xs={6}><Typography variant="h4" color="primary">Front End Version:</Typography></Grid>
          <Grid item xs={6}>{feVersion}</Grid>
          <Grid item xs={6}><Typography variant="h4" color="primary">Jenkins Version:</Typography></Grid>
          <Grid item xs={6}>{jenkinsVersion}</Grid>
        </Grid>
      }
    >
      <Grid>{version}</Grid>
    </Tooltip>);
};

